import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../endpoints';
import { Site } from '../planning';
import { User } from '../users';

export interface ConducsResponse {
    message: string;
    data: { _id: string; firstName: string; lastName: string }[];
}

export const getCurrentConducs = async (): Promise<ConducsResponse> => {
    try {
        const response: AxiosResponse<ConducsResponse> = await apiClient.get('/sites/conducs');
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface MonthlySite {
    site: Site;
    dailySiteByDate: {
        date: string;
        users: User[];
    }[];
}

export interface GetMonthlySiteParams {
    date: string;
}

export interface MonthlySitesResponse {
    data: MonthlySite[];
    message: string;
}

export const getMonthlySites = async (params: GetMonthlySiteParams): Promise<MonthlySitesResponse> => {
    try {
        const response: AxiosResponse<MonthlySitesResponse> = await apiClient.get('/sites/monthly/' + params.date);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface SiteExpense {
    siteId: string;
    siteName: string;
    siteCode: string;
    siteColor?: string;
    siteConducName?: string;
    siteConducUsername?: string;
    totalPrice: number;
}

export interface GetSiteExpensesParams {
    startDate: string;
    endDate: string;
}

export interface SiteExpensesResponse {
    message: string;
    data: {
        sites: SiteExpense[];
        totalExpenses: number;
    };
}

export const getSiteExpensesByDateRange = async (queries: GetSiteExpensesParams): Promise<SiteExpensesResponse> => {
    try {
        const response: AxiosResponse<SiteExpensesResponse> = await apiClient.get('/sites/expenses', {
            params: queries,
        });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
